module.exports = __webpack_public_path__ + "assets/img/axe.dd34a3f0.png";